let prevMarker: customMarker | null = null

export type customMarker = google.maps.Marker & { tagId: number }

export const createStationMarkers = (
  maps: any,
  markers: any[],
  map: google.maps.Map,
  onItemClick: (marker: any, isMarker: boolean) => void
): customMarker[] => {
  const regularMarker = {
    url: "/icons/location-marker.svg",
    size: new maps.Size(53.3, 66.3),
    origin: new maps.Point(0, 0),
    anchor: new maps.Point(17, 25),
    scaledSize: new maps.Size(30, 30),
  }
  const selectedMaker = {
    url: "/icons/location-marker-selected.svg",
    size: new maps.Size(53.3, 66.3),
    origin: new maps.Point(0, 0),
    anchor: new maps.Point(17, 25),
    scaledSize: new maps.Size(30, 30),
  }

  // this is responsible for infoWindow (we dont use it));
  // const infoWindow = new maps.InfoWindow()
  const bounds = new maps.LatLngBounds()
  const markersArray: customMarker[] = []
  markers.map((marker) => {
    const position = {
      lat: marker?.location?.latitude,
      lng: marker?.location?.longitude,
    }
    const markerObject: customMarker = new maps.Marker({
      position,
      icon: regularMarker,
      type: "station",
      optimized: false,
      title: marker.name,
      zIndex: 1,
      map: map,
      tagId: marker.id,
    })
    markersArray.push(markerObject)
    bounds.extend(position)

    markerObject.addListener("click", () => {
      // infoWindow.close()
      markerObject.setIcon(selectedMaker)
      onItemClick(marker, true)
      // marker
      if (prevMarker !== markerObject && prevMarker !== null) {
        prevMarker.setIcon(regularMarker)
      }
      prevMarker = markerObject
      // open infoWindow (we don't use it here)):
      // infoWindow.open(markerObject.getMap(), markerObject)
    })

    markerObject.setIcon(regularMarker)
    // infoWindow.addListener("closeclick", () => {
    //   if (prevMarker) {
    //     prevMarker.setIcon(regularMarker)
    //   }
    // })
  })
  map.fitBounds(bounds)
  const zoom = map.getZoom()
  if (zoom !== undefined) {
    map.setZoom(zoom > 15 ? 15 : zoom)
  }
  return markersArray
}
